"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AperzaCloudApiService = void 0;
var util_1 = require("@aperza/util");
var AcToast_1 = require("../component/notification/AcToast");
var axios = require('axios');
var Cookies = require('js-cookie');
var AperzaCloudApiService = /** @class */ (function () {
    function AperzaCloudApiService() {
    }
    AperzaCloudApiService.getCloudServerHost = function () {
        return util_1.AppService.cloudServerHost();
    };
    AperzaCloudApiService.downloadData = function (_a) {
        var path = _a.path, _b = _a.withCredentials, withCredentials = _b === void 0 ? true : _b, _c = _a.mediaType, mediaType = _c === void 0 ? AperzaCloudApiService.MEDIA_TYPE_PDF : _c, errorMsg = _a.errorMsg;
        var url = "" + AperzaCloudApiService.getCloudServerHost() + path;
        var headers = {
            Accept: mediaType,
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'X-CSRF-TOKEN': Cookies.get('_ctkn'),
        };
        var axiosConfig = {
            url: url,
            responseType: 'arraybuffer',
            headers: headers,
            withCredentials: withCredentials,
        };
        return axios
            .get(url, axiosConfig)
            .then(function (response) {
            return response;
        })
            .catch(function (error) {
            var _a, _b;
            if (((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) === 400 || ((_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.status) === 500) {
                // empty
            }
            AcToast_1.notifyMessage(errorMsg !== null && errorMsg !== void 0 ? errorMsg : 'ダウンロードが行えませんでした。', 'ERROR');
            return null;
        });
    };
    AperzaCloudApiService.downloadFile = function (_a) {
        var path = _a.path, _b = _a.withCredentials, withCredentials = _b === void 0 ? true : _b, filename = _a.filename, mediaType = _a.mediaType, download = _a.download, errorMsg = _a.errorMsg, filenameType = _a.filenameType;
        return AperzaCloudApiService.downloadData({ path: path, withCredentials: withCredentials, mediaType: mediaType, errorMsg: errorMsg }).then(function (response) {
            var _a, _b;
            var blobFilename = filename;
            if (!blobFilename) {
                if (filenameType === 'UTF-8') {
                    blobFilename = decodeURIComponent((_a = response === null || response === void 0 ? void 0 : response.headers['content-disposition']) === null || _a === void 0 ? void 0 : _a.split("UTF-8''")[1]);
                }
                else {
                    blobFilename = (_b = response === null || response === void 0 ? void 0 : response.headers['content-disposition']) === null || _b === void 0 ? void 0 : _b.match(/filename="(.+)"/)[1];
                }
            }
            if (download && response && response.data) {
                util_1.DownloadUtil(response.data, blobFilename);
            }
            return response;
        });
    };
    AperzaCloudApiService.directDownloadData = function (data, filename, mediaType) {
        if (mediaType === void 0) { mediaType = AperzaCloudApiService.MEDIA_TYPE_PDF; }
        util_1.DownloadUtil(data, filename, mediaType);
    };
    AperzaCloudApiService.MEDIA_TYPE_PDF = 'application/pdf';
    AperzaCloudApiService.MEDIA_TYPE_CSV = 'text/csv';
    AperzaCloudApiService.MEDIA_TYPE_ZIP = 'application/zip';
    return AperzaCloudApiService;
}());
exports.AperzaCloudApiService = AperzaCloudApiService;
//# sourceMappingURL=AperzaCloudApiService.js.map